import React from 'react';

import { IMobileSdkTestDetails } from 'src/apps/mobile-sdk/types/MobileSdkServiceTypes';
import { LabelsChips } from 'src/common/components/labels-chips';
import { LABELS_CHIPS_DAID } from 'src/common/components/labels-chips/LabelsChips.constants';
import { IReportInfo } from 'src/common/components/report-info/ReportInfo';
import { formatShortMonthDatetime } from 'src/common/helpers/DateFormatHelper';
import { applyMobileLabelDisplayNames } from 'src/common/helpers/LabelDisplayHelpers';

import './MobileSdkSingleTestHeader.scss';

export const getMobileSdkInfoItems = (
	unitIdDisplayName?: string,
	environmentDisplayName?: string
): IReportInfo[] => {
	return [
		{
			key: 'lastModified',
			label: 'Test date',
			textFormatter: formatShortMonthDatetime
		},
		{
			key: 'sdk',
			label: 'SDK',
			customValueRenderer: ({ sdkType, productVersion }: IMobileSdkTestDetails) => {
				// todo: replace with formatter
				return (
					<>
						<p>{sdkType}</p>
						<p>{productVersion}</p>
					</>
				);
			}
		},
		{
			key: 'app',
			label: 'App',
			customValueRenderer: ({ appName, appVersion }: IMobileSdkTestDetails) => {
				// todo: replace with formatter
				return (
					<>
						<p>{appName}</p>
						<p>{appVersion}</p>
					</>
				);
			}
		},
		{
			key: 'labels',
			label: 'Test labels',
			customValueRenderer: (test: IMobileSdkTestDetails) => {
				const labels = test.labels ?? [];
				return (
					<LabelsChips
						labels={applyMobileLabelDisplayNames(labels, unitIdDisplayName, environmentDisplayName)}
						dataAutomationId={LABELS_CHIPS_DAID}
					/>
				);
			}
		}
	];
};
